import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=36f7d9e0&"
import script from "./MenuGroup.vue?vue&type=script&lang=js&"
export * from "./MenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports